"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomBits = void 0;
const crypto_1 = require("crypto");
exports.randomBits = (bits) => crypto_1.randomBytes(Math.ceil(bits / 8));
//# sourceMappingURL=random-bits.js.map